import { omit } from 'lodash-es';

// `scope` is init-owned too, but it is passed positionally rather than in the register data.
const SCOPE_PROP = 'scope';

/**
 * Drop the fields the server owns from a caller-supplied Shoplytics payload.
 *
 * `shoplytics('init', <scope>, { register })` fixes those fields once per page, but
 * `generateEventPayload` spreads the event payload *after* the register data, so anything a caller
 * still passes silently overrides the server value.
 *
 * The list comes from the same object the server hands to `init`
 * (see `_head_application_js_begin.html.erb`), so a field added to `tracking_register_data` needs no
 * change here.
 */
export function omitRegisterProps(payload) {
  const registerProps = Object.keys(window.SHOPLYTICS_TRACKER_REGISTER ?? {});

  return omit(payload, [...registerProps, SCOPE_PROP]);
}
